type TelegramUser = {
    id: number;
    username?: string;
    first_name?: string;
    last_name?: string;
};

type TelegramWebApp = {
    initDataUnsafe?: {
        user?: TelegramUser;
    };
    close?: () => void;
};

declare global {
    interface Window {
        Telegram?: {
            WebApp?: TelegramWebApp;
        };
    }
}

export function getTelegramUser(): TelegramUser | null {
    return window?.Telegram?.WebApp?.initDataUnsafe?.user ?? null;
}

export function closeTelegramWebApp(): void {
    window?.Telegram?.WebApp?.close?.();
}